import {ApiCalendarVersionDataGroup} from '../../models/api/dataGroupModel';
import {postApiAsync} from '../http/http';
import {HttpResponseError} from '../http/httpError';

const expectedErrorStatuses = [404, 403];

export async function fetchCalendarForOrganizerAddressAsync(
  companyUrl: string,
  namespace: string,
  address: string,
) {
  try {
    const path = `${companyUrl}/namespaces/${namespace}/calendar_versions/find`;
    return await postApiAsync(ApiCalendarVersionDataGroup, path, {address});
  } catch (error) {
    if (error instanceof HttpResponseError && expectedErrorStatuses.includes(error.status)) {
      return undefined;
    }

    throw error;
  }
}
